<template>
<v-app>
   <nav>
   <v-toolbar>
     <v-toolbar-title class="headline text-uppercase">


     </v-toolbar-title>
        Hi, {{ name }}
                 <v-spacer></v-spacer>


     <v-spacer></v-spacer>
  
             <v-btn class="mx-2" fab dark small color="#F50F76" href="/logout">
      <v-icon dark>mdi-logout</v-icon>
    </v-btn>


   </v-toolbar>
 </nav>


        <v-sheet color="#4D96FF" height="25px"></v-sheet>


     <router-view/>


</v-app>

</template>

<script>

export default {


   data: function () {
    return {
      drawer: null,
      name: localStorage.getItem('name'),
      permission: localStorage.getItem('permission'),
      snackbar: false,
      snackbarMessage: "Scan Started...",
      invoiceItems: [
          { title: 'Invoices', icon: 'mdi-receipt', link: '/invoices/'},
          { title: 'Invoice', icon: 'mdi-plus', link: '/invoice/new'},
        ],
      linkItems: [
          { title: 'Links', icon: 'mdi-database', link: '/dashboard' },
          { title: 'Link', icon: 'mdi-plus', link: '/link/new' },
        ]
    }
   },
   created: function (){
     let permission = this.permission
     if(permission == 'cm'){
            this.invoiceItems = [
          { title: 'Invoices', icon: 'mdi-receipt', link: '/invoices/cm'},
          { title: 'Invoice', icon: 'mdi-plus', link: '/invoice/new'},]
     }else if(permission == 'finance'){
       this.linkItems = []
       this.invoiceItems = [{ title: 'Invoices', icon: 'mdi-receipt', link: '/invoices/'}]
     }

   },
   methods: {
     initScan (){

        this.$store.dispatch('initScan')
        .then( response => {
          console.log(response)
          this.snackbarMessage = response.data;
          this.snackbar = true
        })
        .catch( () => {


        })


     }

   }
}
</script>

<style>
.bg-navbar{
background-color: #2a2a72;
background-image: linear-gradient(315deg, #2a2a72 0%, #009ffd 74%);

}
.logo{
    width: 55px;
    height: 40px;
}
</style>
